import { useState } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"
import leftBlack from "./asset/left_black.svg"
import leftGrey from "./asset/left_grey.svg"
import rightBlack from "./asset/right_black.svg"
import rightGrey from "./asset/right_grey.svg"

import MainHeader from "widget/MainHeader"

import useGetNoticeDetail from "entity/notice/useGetNoticeDetail"
import useDeleteNotice from "entity/notice/useDeleteNotice"

import DTStyle from "shared/style/detailTableStyle"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"
import timestampCalculator from "shared/lib/timestampCalculator"

const NoticeDetail = () => {
    const navigate = useNavigate()

    const [imgIndex, setImgIndex] = useState(0)

    const [noticeData] = useGetNoticeDetail()
    const [deleteNotice] = useDeleteNotice()

    const [, setConfirm] = useConfirmModalAtom()

    const btnList = [
        {
            "label": "수정",
            "clickEvent": () => navigate(`/notice/${noticeData?.data?.idx}/edit`),
            "deactive": false
        },
        {
            "label": "삭제",
            "clickEvent": () => setConfirm("정말 삭제할까요?", () => deleteNotice),
            "deactive": false
        },
    ]
    const noticeDataList = [
        {
            "label": "IDX",
            "value": noticeData?.data?.idx
        },
        {
            "label": "제목",
            "value": noticeData?.data?.title
        },
        {
            "label": "생성 날짜",
            "value": timestampCalculator(noticeData?.data?.created_at)
        },
    ]
    const contentData = noticeData?.data?.content
    const imgList = noticeData?.data?.img_list

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <Style.AreaDiv>
                <h2>공지사항 데이터</h2>
                <DTStyle.TableDiv>
                    {noticeDataList?.map((elem, index) =>
                        <DTStyle.TableElement key={index}>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>내용</h2>
                <DTStyle.TableDiv>
                    <DTStyle.TableElement>
                        <h2>본문</h2>
                        <p>{contentData}</p>
                    </DTStyle.TableElement>
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            {imgList?.length > 0 &&
                <Style.AreaDiv>
                    <h2>첨부된 이미지</h2>
                    <Style.SliderDiv>
                        <button onClick={() => setImgIndex(state => state > 0 ? state - 1 : state)}>
                            <img src={imgIndex === 0 ? leftGrey : leftBlack} />
                        </button>
                        <button onClick={() => setImgIndex(state => state < imgList?.length - 1 ? state + 1 : state)}>
                            <img src={imgIndex === imgList?.length - 1 ? rightGrey : rightBlack} />
                        </button>
                    </Style.SliderDiv>
                    <Style.ContentImg src={imgList[imgIndex]} />
                </Style.AreaDiv>
            }

        </Style.Wrapper>
    )
}

export default NoticeDetail